module.exports = __webpack_public_path__ + "files/764361c6a08f001fd9e92eb4defafb17.png";